import { User } from 'types/auth'

import { ROUTES } from '@/constants'

import { isNeverPaidUser } from './isNeverPaidUser'
import { canPerformQrActions } from './userPermissions'

export const getOnboardingLandingRoute = ({
	user,
	qrId,
	isNewAccount,
}: {
	user: User
	qrId?: string | null
	isNewAccount: boolean
}): string => {
	if (isNewAccount || isNeverPaidUser(user)) {
		return ROUTES.checkout.index
	}

	if (!canPerformQrActions(user)) {
		return ROUTES.plans
	}

	if (!qrId) {
		return ROUTES.cabinet.qrCodes
	}

	const searchParams = new URLSearchParams({
		'open-modal': 'qr-code-download',
		id: qrId,
	})
	return `${ROUTES.cabinet.qrCodes}?${searchParams.toString()}`
}
